module.exports = __webpack_public_path__ + "static/media/type-scatter+line.a64fa5a3.svg";